import store from '../store';
import { tradeDetailsSlice } from '../redux/slices/tradeDetails';
import { organizationSlice } from '../redux/slices/organization';
import { mediaMetaDataSlice } from '../redux/slices/media';
import { bidSlice } from '../redux/slices/bid';
import Singleton from '../Singleton';

export default class StoreService extends Singleton<StoreService> {
  private static ACTIONS = {
    SET_TRADE_DETAILS: tradeDetailsSlice.actions.setTradeDetails,
    SET_DEALER_DETAILS: organizationSlice.actions.setOrganizationDealerDetails,
    SET_MEDIA_METADATA: mediaMetaDataSlice.actions.setMediaMetaData,
    SET_BID_LIST: bidSlice.actions.setBidList
  };

  /**
   * This method dispatches an action into the store
   * @param action Action defined by a Redux slice (src/redux/slices/*)
   * @param body content to save into the store
   */
  private save = (actionName, body) => {
    if (actionName in StoreService.ACTIONS) {
      store.dispatch(StoreService.ACTIONS[actionName](body));
    }
  };

  /**
   * Calls action to save Trade Details to the store
   */
  public saveTradeDetails = tradeDetails => {
    this.save('SET_TRADE_DETAILS', tradeDetails);
  };

  public saveOrganizationDealer = dealer => {
    this.save('SET_DEALER_DETAILS', dealer);
  };

  /**
   * Media
   */
  public saveMediaMetaData = metadata => {
    this.save('SET_MEDIA_METADATA', metadata);
  };

  public saveBidList = bidList => {
    this.save('SET_BID_LIST', bidList);
  };
}
